<script>
export default {
    components: {},
    props: {
        modelValue: [String, Object, Number],
        name: String,
        readonly: Boolean,
        hFull: Boolean,
        height10: Boolean,
        height11: Boolean,
        height12: Boolean,

        // select -------------
        selectWidthCustom: { type: String, default: 'w-[150px]' },
        selectPlaceholder: { type: String, default: 'Search Type' },
        selectTypeList: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: [{ text: null, value: null }],
        },

        placeholderTextSmall: {
            type: Boolean,
            default: false,
        },
        selectError: {
            type: Boolean,
            default: false,
        },
        selectDisable: { type: Boolean, default: false },
        fixedSelectVal: { type: Object, default: null },

        // text ---------------
        textWidthCustom: { type: String, default: 'w-[200px]' },
        textPlaceholder: { type: String, default: '' },

        optionClickEvent: Boolean,
        hasSearchButton: Boolean,
        buttonClassProps: {
            type: String,
            default: 'w-24 h-12 text-[#4261EE]',
        },
        btnColorGray: Boolean,
    },
    emits: ['change', 'update:modelValue', 'searchEvent'],
    data() {
        return {
            schType: { value: '', text: '' },
            showType: false,
            schKeyword: '',
        };
    },
    methods: {
        // Text Bar ----------------------------------------------------------------------------------------------------
        onInput(event) {
            const self = this;
            self.schKeyword = event.target.value;

            self.$emit('update:modelValue', self.schKeyword);
        },
        setInputText(value = null) {
            const self = this;
            self.schKeyword = value;

            self.$emit('update:modelValue', self.schKeyword);
        },
        searchEvent() {
            const self = this;
            console.log('self.schType:', self.schType, ' / self.schKeyword: ', self.schKeyword);

            // type이 2개 이상이면서, 'type 선택 / 키워드 입력' 둘 중 하나를 안 헀을 경우 알림 발생
            if (self.fixedSelectVal == null && ((self.schKeyword != '' && (!self.schType || self.schType.value == '')) || (self.schKeyword == '' && self.schType.value != ''))) {
                alert('Please select search Type or enter the search keyword.');
                return;
            }
            self.showType = false;
            self.$emit('searchEvent');
        },
        getSearchedText() {
            // 부모 쪽에서 사용
            const self = this;
            return self.schKeyword;
        },
        getSearchedValues() {
            // 부모 쪽에서 사용
            const self = this;
            if (self.schKeyword == null || self.schKeyword == '') {
                return null;
            }
            if (self.fixedSelectVal != null) {
                self.schType.value = self.fixedSelectVal.value;
                self.schType.text = self.fixedSelectVal.text;
            }
            let costCenter = {
                schType: self.schType.value,
                schKeyword: self.schKeyword,
            };
            return costCenter;
        },

        // Select Bar ----------------------------------------------------------------------------------------------------
        clickSelectBox() {
            const self = this;
            if (!self.selectDisable) {
                self.showType = !self.showType;
            }
        },
        clickSelectType(type) {
            const self = this;
            self.schType.text = type.text;
            self.schType.value = type.value;
            self.clickSelectBox();
        },
    },
};
</script>

<template>
    <div class="flex gap-2">
        <!-- select box --------------------------------------------------------------------------------->
        <div class="relative bg-white h-12 flex justify-start mb-4" :class="[selectWidthCustom]">
            <div
                class="relative border border-gray-300 rounded-lg py-1 px-3 max-w-6xl h-12 bg-white transition-all duration-500 shadow shadow-gray-100"
                :class="[
                    {
                        'border-red-500': selectError,
                        'bg-gray-200': selectDisable,
                        'h-12': height12,
                    },
                    selectWidthCustom,
                ]"
                :disable="selectDisable">
                <a @click="clickSelectBox" class="w-full h-full text-sm font-semi-bold cursor-pointer flex justify-between items-center" href="javascript:void(0)">
                    <div class="truncate" :class="[!schType && selectPlaceholder ? 'text-gray-400' : '', selectWidthCustom]">
                        {{ fixedSelectVal ? fixedSelectVal.text : schType.text ? schType.text : selectPlaceholder }}
                    </div>
                    <img src="@/assets/img/elements-select-1.svg" alt="elements-select-1" v-show="!readonly" />
                </a>
                <div
                    v-show="showType"
                    class="absolute top-11 left-0 w-60 border rounded-sm max-w-6xl max-h-60 bg-white transition-all duration-500 shadow shadow-gray-100 overflow-auto z-10"
                    :class="{
                        'border-red-500': selectError,
                    }">
                    <a
                        v-for="type in selectTypeList"
                        :key="type.value"
                        :disable="readonly"
                        href="javascript:void(0)"
                        @click="readonly === true ? doNothing : clickSelectType(type)"
                        class="block px-3 py-0.5 w-full bg-white transition-all duration-500 cursor-pointer text-sm hover:bg-blue-500 hover:text-white"
                        :class="{
                            'bg-gray-300 hover:bg-gray-300 hover:text-black': readonly,
                        }">
                        {{ type.text }}
                    </a>
                </div>
            </div>
        </div>

        <!-- text input box --------------------------------------------------------------------------------->
        <div class="relative border border-gray-300 rounded-lg w-full h-full flex justify-start">
            <input
                type="text"
                v-model="schKeyword"
                @keyup.enter="searchEvent"
                @input="onInput"
                class="p-2 text-left cursor-default max-w-6xl border-t-0 border-b-0 border-l-0 border-r-1 border-gray-300 rounded-l-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                :class="[
                    {
                        'h-full': hFull,
                        'h-10': height10,
                        'h-11': height11,
                        'h-12': height12,
                        'bg-gray-100': readonly,
                    },
                    textWidthCustom,
                ]"
                :placeholder="textPlaceholder" />
            <button v-if="hasSearchButton" @click="searchEvent" :class="[{ 'bg-[#F3F4F6] border border-[#D6DDEB] rounded-r-lg': btnColorGray }, buttonClassProps]">Search</button>
        </div>
    </div>
</template>

<style></style>
